import type { Plan } from "../redux/api";

// "IN" shows the plan's own price/currency as-is (today, always INR).
// "INTL" shows usdMonthlyPrice/usdYearlyPrice — set independently by the
// platform owner, not an FX conversion. A stepping stone toward full
// per-country pricing later.
export type Region = "IN" | "INTL";

export const regionForCountry = (iso2: string): Region =>
  iso2 === "IN" ? "IN" : "INTL";

export const currencySymbol = (currency?: string | null) =>
  (currency ?? "").toUpperCase() === "USD" ? "$" : "₹";

export const regionAmount = (
  plan: Plan,
  region: Region,
  period: "monthly" | "yearly",
) => {
  if (region === "IN") return period === "monthly" ? plan.monthlyPrice : plan.yearlyPrice;
  return period === "monthly" ? plan.usdMonthlyPrice : plan.usdYearlyPrice;
};

export const priceLabel = (plan: Plan, region: Region) => {
  if ((plan.code ?? "").toUpperCase() === "CUSTOM") return "Custom";
  const amount = regionAmount(plan, region, "monthly");
  if (!amount) return "Free";
  const symbol = region === "IN" ? currencySymbol(plan.currency) : "$";
  return `${symbol}${amount.toLocaleString()}`;
};
